(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerWrapper = document.querySelector('.header-wrapper')
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

//if (this.headerIsAlwaysSticky) {
//this.header.classList.add('shopify-section-header-sticky');
//this.header.classList.add('always-fixed');
//};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.searchOverlay = document.querySelector('.search-modal__overlay');

	if (this.searchOverlay) {
		this.searchOverlay.addEventListener('click', function(){
			const searchModal = document.querySelector('details-modal');
			searchModal.close();
		})
	}

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 50) {
	this.header.classList.add('shopify-section-header-sticky');
};

if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight / 2) {
	this.header.classList.remove('shopify-section-header-sticky');
};
if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
}else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
      );

      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector(
              'product-recommendations--single'
            );

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };

      new IntersectionObserver(
        handleIntersection.bind(this),
        { rootMargin: '0px 0px 200px 0px' }
      ).observe(this);
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  if (!customElements.get('product-recommendations--single')) {
    customElements.define(
      'product-recommendations--single',
      ProductRecommendations
    );
  }

  (() => {
    if (window.RevherbProductLayout) {
      window.RevherbProductLayout.init(document);
      return;
    }

    class RevherbProductLayout {
      constructor(root) {
        this.root = root;
        this.abort = new AbortController();
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.outer = root.querySelector('.product__outer');
        this.heading = root.querySelector('.rh-heading');

        this.headingHome = document.createComment(
          'REVHERB heading position'
        );

        if (this.heading) {
          this.heading.before(this.headingHome);
        }

        this.movedRating = null;
        this.sticky = root.querySelector('[data-rh-sticky]');
        this.stickyButton = root.querySelector('[data-rh-sticky-button]');
        this.price = root.querySelector('[data-rh-sticky-price]');
        this.mode = root.querySelector('[data-rh-sticky-mode]');
        this.gallery = root.querySelector('.js-media-list');
        this.galleryStatus = root.querySelector('[data-rh-gallery-status]');
        this.education = root.querySelector('[data-rh-education]');
        this.reviewSlot = root.querySelector('[data-rh-review-slot]');
        this.reviewPanel = root.querySelector('[data-rh-reviews-panel]');
        this.reviewFallback = root.querySelector('[data-rh-review-fallback]');
        this.reviewWidget = null;
        this.reviewHome = null;
        this.observedSwiper = null;
        this.destroyed = false;
        this.frame = null;

        try {
          this.data = JSON.parse(
            root.querySelector('[data-rh-product-data]')?.textContent || '{}'
          );
        } catch {
          this.data = {};
        }

        this.variants = new Map(
          (this.data.variants || []).map(variant => [
            String(variant.id),
            variant
          ])
        );

        try {
          this.money = new Intl.NumberFormat(
            document.documentElement.lang || 'en',
            {
              style: 'currency',
              currency: this.data.currency || 'USD'
            }
          );
        } catch {
          this.money = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          });
        }

        this.onMedia = () => {
          this.layout();
          this.queue();
        };

        this.mobile.addEventListener('change', this.onMedia);

        root.addEventListener(
          'click',
          event => this.click(event),
          { signal: this.abort.signal }
        );

        root.addEventListener(
          'change',
          () => this.queue(),
          { signal: this.abort.signal }
        );

        root.addEventListener(
          'input',
          () => this.queue(),
          { signal: this.abort.signal }
        );

        root.addEventListener(
          'toggle',
          event => this.onToggle(event),
          {
            capture: true,
            signal: this.abort.signal
          }
        );

        document.addEventListener(
          'scroll',
          () => this.queue(),
          {
            passive: true,
            signal: this.abort.signal
          }
        );

        document.addEventListener(
          'focusin',
          () => this.queue(),
          { signal: this.abort.signal }
        );

        document.addEventListener(
          'focusout',
          () => this.queue(),
          { signal: this.abort.signal }
        );

        window.addEventListener(
          'resize',
          () => this.queue(),
          {
            passive: true,
            signal: this.abort.signal
          }
        );

        this.observer = new MutationObserver(() => this.queue());

        this.observer.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'disabled',
            'aria-disabled',
            'class',
            'value',
            'checked',
            'data-number-of-reviews'
          ]
        });

        this.modalObserver = new MutationObserver(() => this.queue());

        this.modalObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });

        this.reviewsObserver = new MutationObserver(() => this.queue());

        if (this.reviewSlot) {
          this.reviewsObserver.observe(document.body, {
            childList: true,
            subtree: true
          });
        }

        this.resizeObserver = new ResizeObserver(() => this.queue());

        if (this.sticky) {
          this.resizeObserver.observe(this.sticky);
        }

        this.spacer = document.createElement('div');
        this.spacer.setAttribute('aria-hidden', 'true');
        this.spacer.dataset.rhStickySpacer = root.id;
        document.body.append(this.spacer);

        this.layout();
        this.update();

        this.timer = window.setInterval(() => {
          if (this.mobile.matches && !document.hidden) {
            this.queue();
          }
        }, 500);
      }

      get form() {
        return document.getElementById(this.root.dataset.rhFormId);
      }

      get mainButton() {
        return this.form?.querySelector('[name="add"]');
      }

      queue() {
        if (this.destroyed || this.frame !== null) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      setText(element, value) {
        if (element && element.textContent !== value) {
          element.textContent = value;
        }
      }

      layout() {
        if (this.heading) {
          if (
            this.mobile.matches &&
            this.heading.parentElement !== this.outer
          ) {
            this.outer.prepend(this.heading);
          }

          if (
            !this.mobile.matches &&
            this.headingHome.parentNode &&
            this.heading.previousSibling !== this.headingHome
          ) {
            this.headingHome.after(this.heading);
          }
        }

        this.moveRating();
      }

      moveRating() {
        if (!this.heading) return;

        if (!this.movedRating) {
          const badge = this.root.querySelector(
            '.rh-block--app .jdgm-preview-badge'
          );

          const block = badge?.closest('.rh-block--app');

          if (block && !block.querySelector('.jdgm-review-widget')) {
            const home = document.createComment(
              'REVHERB rating position'
            );

            block.before(home);
            this.movedRating = { block, home };
          }
        }

        const moved = this.movedRating;

        if (!moved) return;

        if (
          this.mobile.matches &&
          moved.block.parentNode !== this.heading
        ) {
          this.heading.append(moved.block);
        }

        if (
          !this.mobile.matches &&
          moved.home.parentNode &&
          moved.block.previousSibling !== moved.home
        ) {
          moved.home.after(moved.block);
        }
      }

      mountReviews() {
        if (!this.reviewSlot || this.reviewWidget) return;

        const widget = [
          ...document.querySelectorAll(
            '.jdgm-review-widget, #judgeme_product_reviews'
          )
        ].find(element => {
          return (
            !this.root.contains(element) &&
            !element.contains(this.root)
          );
        });

        if (!widget) return;

        this.reviewHome = document.createComment(
          'REVHERB original reviews position'
        );

        widget.before(this.reviewHome);
        this.reviewWidget = widget;
        this.reviewSlot.append(widget);

        if (this.reviewFallback) {
          this.reviewFallback.hidden = true;
        }

        this.reviewsObserver.disconnect();
      }

      updateReviewCount() {
        const badge = this.root.querySelector(
          '.jdgm-preview-badge [data-number-of-reviews]'
        );

        const raw = (
          badge?.getAttribute('data-number-of-reviews') ??
          this.reviewWidget?.getAttribute('data-number-of-reviews') ??
          this.reviewWidget
            ?.querySelector('[data-number-of-reviews]')
            ?.getAttribute('data-number-of-reviews')
        );

        const count = Number.parseInt(raw, 10);

        this.setText(
          this.root.querySelector('[data-rh-review-count]'),
          Number.isFinite(count) && count >= 0 ? ` (${count})` : ''
        );
      }

      onToggle(event) {
        if (
          event.target !== this.reviewPanel ||
          !this.reviewPanel.open
        ) {
          return;
        }

        this.mountReviews();
        this.updateReviewCount();

        requestAnimationFrame(() => {
          if (!this.destroyed) {
            window.dispatchEvent(new Event('resize'));
          }
        });
      }

      readSelection() {
        const form = this.form;
        const values = form ? new FormData(form) : null;

        const variant = this.variants.get(
          String(values?.get('id') || '')
        );

        const planId = String(values?.get('selling_plan') || '');

        const allocation = variant?.allocations?.find(
          allocation => String(allocation.id) === planId
        );

        return { variant, planId, allocation };
      }

      overlayOpen() {
        if (
          document.body.classList.contains('overflow-hidden') ||
          document.body.classList.contains('overflow-hidden-mobile')
        ) {
          return true;
        }

        const candidates = document.querySelectorAll(
          'cart-drawer.active, cart-drawer[open], dialog[open], [aria-modal="true"]'
        );

        return [...candidates].some(element => {
          return (
            !element.closest('.rh-product') &&
            element.getClientRects().length > 0 &&
            getComputedStyle(element).visibility !== 'hidden' &&
            getComputedStyle(element).display !== 'none'
          );
        });
      }

      update() {
        if (!this.root.isConnected) {
          this.destroy();
          return;
        }

        this.moveRating();
        this.mountReviews();
        this.updateReviewCount();
        this.updateGallery();

        const { variant, planId, allocation } = this.readSelection();
        const main = this.mainButton;

        if (!this.sticky || !main) return;

        const missingSelection = (
          !variant ||
          (variant.requires_selling_plan && !planId) ||
          (planId && !allocation)
        );

        const busy = (
          main.classList.contains('loading') ||
          main.getAttribute('aria-disabled') === 'true'
        );

        const disabled = (
          !!variant &&
          !missingSelection &&
          (!variant.available || main.disabled || busy)
        );

        const amount = allocation ? allocation.price : variant?.price;

        this.setText(
          this.price,
          amount == null ? '' : this.money.format(amount / 100)
        );

        this.setText(
          this.mode,
          allocation?.name || (
            missingSelection
              ? this.data.chooseOptions
              : this.data.oneTime
          )
        );

        this.setText(
          this.stickyButton,
          missingSelection
            ? this.data.chooseOptions
            : !variant.available
              ? this.data.soldOut
              : this.data.addToCart
        );

        if (this.stickyButton.disabled !== disabled) {
          this.stickyButton.disabled = disabled;
        }

        const rect = main.getBoundingClientRect();
        const viewport = (
          window.innerHeight ||
          document.documentElement.clientHeight
        );

        const mainVisible = (
          rect.height > 0 &&
          rect.bottom > 0 &&
          rect.top < viewport
        );

        const active = document.activeElement;

        const enteringText = (
          active &&
          this.root.contains(active) &&
          active.matches(
            'textarea, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="number"])'
          )
        );

        const show = (
          this.mobile.matches &&
          !mainVisible &&
          !enteringText &&
          !this.overlayOpen()
        );

        if (this.sticky.hidden === show) {
          this.sticky.hidden = !show;
        }

        const height = show
          ? this.sticky.getBoundingClientRect().height
          : 0;

        const space = `${Math.ceil(height)}px`;

        if (this.spacer.style.height !== space) {
          this.spacer.style.height = space;
        }
      }

      click(event) {
        const thumb = event.target.closest('[data-rh-media-target]');

        if (thumb && this.root.contains(thumb)) {
          const slides = [
            ...this.gallery.querySelectorAll(
              '.swiper-slide[data-media-id]'
            )
          ];

          const index = slides.findIndex(slide => {
            return slide.dataset.mediaId === (
              `${this.root.dataset.section}-${thumb.dataset.rhMediaTarget}`
            );
          });

          if (
            index >= 0 &&
            this.gallery.swiper &&
            !this.gallery.swiper.destroyed
          ) {
            this.gallery.swiper.slideTo(index);
          }

          return;
        }

        const reviewLink = event.target.closest(
          '[data-rh-reviews-link]'
        );

        if (reviewLink) {
          const reviews = (
            document.getElementById('judgeme_product_reviews') ||
            document.querySelector('.jdgm-review-widget')
          );

          if (reviews) {
            event.preventDefault();

            reviews.scrollIntoView({
              behavior: this.reducedMotion() ? 'auto' : 'smooth',
              block: 'start'
            });
          }

          return;
        }

        if (!event.target.closest('[data-rh-sticky-button]')) return;

        const main = this.mainButton;
        const { variant, planId, allocation } = this.readSelection();

        if (!main) return;

        if (
          !variant ||
          (variant.requires_selling_plan && !planId) ||
          (planId && !allocation)
        ) {
          this.form.scrollIntoView({
            behavior: this.reducedMotion() ? 'auto' : 'smooth',
            block: 'center'
          });

          const control = this.root.querySelector(
            'variant-selects select, variant-radios input, [name="selling_plan"]:not([type="hidden"])'
          );

          control?.focus({ preventScroll: true });
          return;
        }

        if (
          main.disabled ||
          main.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        main.click();
        this.queue();
      }

      reducedMotion() {
        return window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;
      }

      updateGallery() {
        const swiper = this.gallery?.swiper;

        if (!swiper || swiper.destroyed) return;

        if (this.observedSwiper !== swiper) {
          if (
            this.observedSwiper &&
            !this.observedSwiper.destroyed
          ) {
            this.observedSwiper.off(
              'slideChange',
              this.galleryListener
            );
          }

          this.observedSwiper = swiper;
          this.galleryListener = () => this.queue();
          swiper.on('slideChange', this.galleryListener);
        }

        const slides = [
          ...this.gallery.querySelectorAll(
            '.swiper-slide[data-media-id]'
          )
        ];

        const current = slides[swiper.activeIndex || 0];

        this.root.querySelectorAll('[data-rh-media-target]').forEach(thumb => {
          const selected = current?.dataset.mediaId === (
            `${this.root.dataset.section}-${thumb.dataset.rhMediaTarget}`
          );

          const value = String(selected);

          if (thumb.getAttribute('aria-pressed') !== value) {
            thumb.setAttribute('aria-pressed', value);
          }
        });

        this.setText(
          this.galleryStatus,
          `${(swiper.activeIndex || 0) + 1} / ${slides.length}`
        );
      }

      destroy() {
        if (this.destroyed) return;

        this.destroyed = true;
        this.abort.abort();
        this.mobile.removeEventListener('change', this.onMedia);
        this.observer.disconnect();
        this.modalObserver.disconnect();
        this.resizeObserver.disconnect();
        this.reviewsObserver.disconnect();

        if (this.reviewWidget && this.reviewHome?.parentNode) {
          this.reviewHome.before(this.reviewWidget);
          this.reviewHome.remove();
        }

        if (this.reviewFallback) {
          this.reviewFallback.hidden = false;
        }

        clearInterval(this.timer);

        if (this.frame !== null) {
          cancelAnimationFrame(this.frame);
        }

        if (
          this.observedSwiper &&
          !this.observedSwiper.destroyed
        ) {
          this.observedSwiper.off(
            'slideChange',
            this.galleryListener
          );
        }

        this.spacer.remove();

        if (this.sticky) {
          this.sticky.hidden = true;
        }

        this.root.rhProductController = null;
      }

      static init(scope) {
        const roots = scope.matches?.('[data-rh-product-section]')
          ? [scope]
          : [...scope.querySelectorAll('[data-rh-product-section]')];

        roots.forEach(root => {
          if (!root.rhProductController) {
            root.rhProductController = new RevherbProductLayout(root);
          }
        });
      }
    }

    window.RevherbProductLayout = RevherbProductLayout;

    const init = () => RevherbProductLayout.init(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', event => {
      RevherbProductLayout.init(event.target);
    });

    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-rh-product-section]').forEach(root => {
        root.rhProductController?.destroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        if (this.querySelector('.product-recommendations__loading')) {
          this.querySelector('.product-recommendations__loading').classList.add('loading');
          this.querySelector('.product-recommendations__loading').style.display = 'flex';
        }

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.querySelector('.product-recommendations__loading')) {
						  this.querySelector('.product-recommendations__loading').classList.remove('loading');
					  }

            if (document.querySelector('.steps-section')) {
              ScrollTrigger.getAll().forEach((el) => el.kill());

              const setStepsParallaxOpt = (elem) => {
                elem.setAttribute('data-parallax-property-value', '-40');
                elem.setAttribute('data-parallax-steps', '0, 40');
                elem.setAttribute('data-parallax-property', 'translateY');
              };

              const removeStepsParallaxOpt = (elem) => {
                elem.removeAttribute('data-parallax-property-value');
                elem.removeAttribute('data-parallax-steps');
                elem.removeAttribute('data-parallax-property');
                elem.removeAttribute('style');
              };

              const calcDurationScroll = (elem) => {
                switch (elem.length) {
                  case 1:
                    return 'bottom bottom';
                  case 2:
                    return '+=80%';
                  case 3:
                    return '+=140%';
                  case 4:
                    return '+=180%';
                  case 5:
                    return '+=200%';
                }
              };

              const initStepsParallax = () => {
                const stepsSections = document.querySelectorAll('.steps-section');

                stepsSections.forEach((elem) => {
                  const parallax = elem.querySelectorAll('.steps__scroll-parallax');

                  parallax.forEach((elem) => {
                    if (window.matchMedia('(min-width: 990px)').matches) {
                      elem.classList.add('js-parallax');
                      setStepsParallaxOpt(elem);
                    } else {
                      elem.classList.remove('js-parallax');
                      removeStepsParallaxOpt(elem);
                    }
                  });
                });
              };

              const initStepsAnim = () => {
                const containers = document.querySelectorAll('.steps');

                containers.forEach((elem) => {
                  ScrollTrigger.matchMedia({
                    '(min-width: 990px)': function () {
                      const slides = elem.querySelectorAll('.steps__slide-item--desktop');
                      let parallax = elem.querySelector('.steps__scroll');
                      let progress = [];

                      slides.forEach((elem, index) => {
                        progress.push((1 / slides.length) * index - 1 / slides.length / 2);
                      });

                      progress.push(1);

                      const removeActiveClass = () => {
                        slides.forEach((elem) => {
                          elem.classList.remove('active');
                        });
                      };

                      let st = ScrollTrigger.create({
                        trigger: elem,
                        start: 'top top',
                        end: calcDurationScroll(slides),
                        invalidateOnRefresh: true,
                        animation: parallax
                          ? gsap.fromTo(parallax, { y: 0 }, { y: -(parallax.scrollHeight - elem.clientHeight + 310) })
                          : false,
                        pin: true,
                        scrub: 0.5,
                        onRefresh: (self) => {
                          for (let i = 0; i <= slides.length; i++) {
                            if (self.progress > progress[i] && self.progress < progress[i + 1]) {
                              removeActiveClass();
                              slides[0].classList.remove('active');
                              slides[i].classList.add('active');
                              slides[i].classList.remove('prev');
                            }
                          }
                        },
                        onUpdate: (self) => {
                          for (let i = 0; i <= slides.length; i++) {
                            if (self.progress > progress[i] && self.progress < progress[i + 1]) {
                              if (!slides[i].classList.contains('active')) {
                                removeActiveClass();
                                slides[i].classList.add('active');
                                slides[i].classList.remove('prev');

                                for (let el of slides) {
                                  if (el.classList.contains('active')) break;
                                  el.classList.add('prev');
                                }
                              }
                            }
                          }
                        },
                      });
                    },
                    '(max-width: 989px)': function () {
                      if (elem.querySelector('.steps__scroll') !== null) {
                        elem.querySelector('.steps__scroll').style.transform = 'translate3d(0, 0, 0)';
                        ScrollTrigger.getAll().forEach((el) => el.kill());
                      }
                    },
                  });
                });
              };

              setTimeout(() => {
                initStepsAnim();
                initStepsParallax();
              }, 300);
            }
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
